import { useAppStore } from '@/store/client';
import type { SessionProps } from '../types';
import { SessionGroupContent } from './session-group-content';
import { SessionGroupEditorContext } from './session-group-editor-context';

export interface SessionGroupProps extends SessionProps {}

export function SessionGroup({ sessionStoreInstance, ...props }: SessionGroupProps) {
  const mediaStores = useAppStore((store) => store.mediaStores);

  const sessionId = useMemo(() => {
    return sessionStoreInstance.getState().session!.chat_id;
  }, [sessionStoreInstance]);

  const mediaStoreInstance = useMemo(() => {
    return mediaStores[sessionId];
  }, [mediaStores, sessionId]);

  return (
    <SessionGroupEditorContext sessionStoreInstance={sessionStoreInstance}>
      <SessionGroupContent
        {...props}
        sessionStoreInstance={sessionStoreInstance}
        mediaStoreInstance={mediaStoreInstance}
      ></SessionGroupContent>
    </SessionGroupEditorContext>
  );
}
